export default {
  title: 'Kampagnen-Performance',
  recipients: '{{recipients}} Empfänger',
  error_messages: {
    failed_to_load_data: 'Daten konnten nicht geladen werden',
  },
};
